import { GraphQLClient } from 'graphql-request';
import { Optional } from '@fiverr-private/homepage_common_types';
import { logger } from '@fiverr-private/obs';
import { statsFunctionWrapper } from '@fiverr-private/homepage_utils';
import { GetOrdersForTailoredHomepageJtbdCardDocument } from '@fiverr-private/homepage_gql_utils';
import { Order } from '../../types/gqlTypes';

const sanitizeOrders = (nodes: Optional<Optional<Order>[]>): Order[] =>
    nodes?.filter((node): node is Order => !!node) ?? [];

export const getOrders = async (route: string, userId: number): Promise<Order[]> => {
    try {
        const client = new GraphQLClient(route);
        const fetcher = () =>
            client.request(GetOrdersForTailoredHomepageJtbdCardDocument, {
                buyerId: userId.toString(),
            });

        const {
            searchOrders: { nodes },
        } = await statsFunctionWrapper(fetcher, 'jtbd.order_updates.get_orders')();

        return sanitizeOrders(nodes);
    } catch (error: any) {
        // TODO: Verify error payload structure
        if (error?.response?.data?.searchOrders?.nodes) {
            logger.error(error, {
                description: 'Failed to fetch orders, but got a response',
                source: 'getOrders',
                buyerId: userId,
                route,
                responseData: error.response.data,
            });

            return sanitizeOrders(error.response.data.searchOrders.nodes);
        }

        logger.error(error, {
            description: 'Failed to fetch orders',
            source: 'getOrders',
            buyerId: userId,
            route,
        });

        return [];
    }
};
